// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileTextTwoToneSvg from "@fishx/icons-svg/es/asn/FileTextTwoTone";
import FishxIcon from '../components/FishxIcon';

var FileTextTwoTone = function FileTextTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileTextTwoToneSvg
  }));
};

FileTextTwoTone.displayName = 'FileTextTwoTone';
export default React.forwardRef(FileTextTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileTextTwoTone.js
// module id = 2752
// module chunks = 0